import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  FETCH_SIGN_UP_DATA_URL,
  UNSUBSCRIBE_EMAIL_URL,
  UNSUBSCRIBE_EMAIL_URL_BY_TOKEN,
  CHANGE_PASSWORD_URL,
  SIGN_UP_EMAIL_CHECK_URL,
  RESEND_EMAIL_CONFIRMATION_URL,
  FETCH_PROFILE_URL,
  CHANGE_EMAIL_URL,
  UPDATE_PRIVACY_SETTINGS_URL,
  ADD_ADDITIONAL_EMAIL_URL,
  DELETE_ADDITIONAL_EMAIL_URL,
  RESEND_ADDITIONAL_EMAIL_URL,
  UPDATE_LANGUAGE_URL,
  UPDATE_UNITS_URL,
  FETCH_PLAYER_POSITIONS_URL} from '@/constants/ApiConstants'
import * as mutation from '@/store/mutation.types'

const state = {
  account: window.localStorage.getItem('account') ? JSON.parse(window.localStorage.getItem('account')) : {},
  subAccounts: [],
  additionalEmails: [],
  playerPositions: []
}

const getters = {
  account: (state) => state.account,
  subAccounts: (state) => state.subAccounts,
  additionalEmails: (state) => state.account.additionalEmailAddresses,
  playerPositions: (state) => state.playerPositions
}

const actions = {
  [action.FETCH_SIGN_UP_DATA] (context, token) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(`${FETCH_SIGN_UP_DATA_URL.replace(':token', token)}`)
        .then((response) => {
          
          return resolve(response)
        })
        .catch(error => {
          context.commit(mutation.SET_ERROR, error)
          return reject(error)
        })
    })
  },
  [action.EMAIL_CHECK] (context, { token, credentials }) {
    return new Promise(resolve => {
      ApiService
        .get(`${SIGN_UP_EMAIL_CHECK_URL.replace(':token', token)}`, credentials)
        .then(({ data }) => {
          resolve(data)
        })
    })
  },
  [action.RESEND_EMAIL_CONFIRMATION] () {
    return new Promise((resolve, reject) => {
      ApiService
        .put(RESEND_EMAIL_CONFIRMATION_URL)
        .then(({ data }) => {
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.CHANGE_PASSWORD] (context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(CHANGE_PASSWORD_URL, credentials.data)
        .then(({ data }) => {
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_PROFILE_DATA] ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(`${FETCH_PROFILE_URL.replace(':accountId', payload)}`)
          .then(({ data }) => {          
            if(data.playerDetails) {
              commit(mutation.SET_SUBACCOUNTS, data.playerDetails)
              let chosenAccount = data.playerDetails.filter(player => player.playerId === state.account.playerId)
              commit(mutation.SET_CHOSEN_ACCOUNT, chosenAccount.length ? chosenAccount[0] : {})
            } else {
              commit(mutation.SET_CHOSEN_ACCOUNT, data)
            }
            commit(mutation.UPDATE_PROFILE, data)
            return resolve(data)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.UNSUBSCRIBE_EMAIL] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .patch(`${UNSUBSCRIBE_EMAIL_URL.replace(':subscriptionId', payload.subscriptionId)}`, {subscribed: payload.subscribed})
        .then(({ data }) => {
          return resolve(data);
        })
        .catch(error => {
          return reject(error);
        })
    })
  },
  [action.UNSUBSCRIBE_EMAIL_BY_TOKEN] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .patch(`${UNSUBSCRIBE_EMAIL_URL_BY_TOKEN.replace(':token', payload.token)}`, {subscribed: payload.subscribed})
        .then(({ data }) => {
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.EDIT_EMAIL] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(`${CHANGE_EMAIL_URL.replace(':accountId', payload.accountId)}`, payload)
        .then(({ data }) => {
          commit(mutation.EDIT_EMAIL, payload.email);
          commit(mutation.EDIT_USER_EMAIL, payload.email);
          return resolve(data);
        })
        .catch(error => {
          return reject(error);
        })
    })
  },
  [action.UPDATE_PRIVACY] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .put(`${UPDATE_PRIVACY_SETTINGS_URL.replace(':playerId', payload.playerId).replace(':privacyBoolean', payload.privacy)}`)
        .then(({ data }) => {
          commit(mutation.UPDATE_PRIVACY, payload.privacy);
          return resolve(data);
        })
        .catch(error => reject(error))
    })
  },
  [action.ADD_ADDITIONAL_EMAIL]({commit}, {playerId, email}) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(`${ADD_ADDITIONAL_EMAIL_URL.replace(':playerId', playerId)}`, email, 'text/plain')
          .then(({data}) => {
            commit(mutation.SET_ADDITIONAL_EMAIL, data)
            return resolve(data);
          })
          .catch(error => {
            return reject(error);
          })
    })
  },
  [action.DELETE_ADDITIONAL_EMAIL] ({ commit }, { playerId, emailId }) {
    return new Promise((resolve, reject) => {
      ApiService
        .delete(`${DELETE_ADDITIONAL_EMAIL_URL.replace(':playerId', playerId).replace(':emailId', emailId)}`)
          .then(response => {
            commit(mutation.REMOVE_ADDITIONAL_EMAIL, emailId)
            resolve(response)
          })
          .catch(error => {
            return reject(error);
          })
    })
  },
  [action.RESEND_ADDITIONAL_EMAIL] ({ commit }, { playerId, emailId}) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(`${RESEND_ADDITIONAL_EMAIL_URL.replace(':playerId', playerId).replace(':emailId', emailId)}`)
        .then(({ data }) => {
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.UPDATE_LANGUAGE]({commit}, payload ) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(`${UPDATE_LANGUAGE_URL.replace(':accountId', payload.accountId)}`, { language :payload.language })
        .then(({data}) => {
          commit(mutation.UPDATE_LANGUAGE, payload.language);
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.UPDATE_UNITS]({commit}, payload ) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(`${UPDATE_UNITS_URL.replace(':id', payload.playerId)}`, { unitDistance: payload.unitDistance, unitHeightWeight: payload.unitHeightWeight })
        .then(({data}) => {
          commit(mutation.UPDATE_UNITS, { unitDistance: payload.unitDistance, unitHeightWeight: payload.unitHeightWeight });
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_PLAYER_POSITIONS]({commit}, payload) {
    return new Promise((resolve, reject) => {
      ApiService.get(FETCH_PLAYER_POSITIONS_URL)
        .then(response => {
          commit(mutation.SET_PLAYER_POSITIONS, response.data);
        })
        .catch(error => console.log(error))
    })
  }
}

const mutations = {
  [mutation.SET_CHOSEN_ACCOUNT] (state, payload) {
    const modifiedPhoneNumber = payload;
    if (modifiedPhoneNumber.phone === null) {
      modifiedPhoneNumber.phone = {
        countryCode : null,
        number: null
      }
    }
    state.account = modifiedPhoneNumber
    window.localStorage.setItem('account', JSON.stringify(modifiedPhoneNumber))
  },
  [mutation.UPDATE_ACCOUNTS] (state, payload) {
    state.subAccounts = state.subAccounts.map((account) => {
      if(account.playerId === payload.playerId) {
        state.account = payload
        return payload
      }

      return account
    })
  },
  [mutation.SET_SUBACCOUNTS] (state, payload) {
    state.subAccounts = payload
  },
  [mutation.EDIT_EMAIL] (state, payload) {
    state.account.newEmail = payload;
  },
  [mutation.UPDATE_PRIVACY] (state, payload) {
    state.account.activityPrivacy = payload;
  },
  [mutation.UPDATE_LANGUAGE] (state, payload) {
    state.account.language = payload;
  },
  [mutation.UPDATE_UNITS] (state, payload) {
    state.account.unitDistance = payload.unitDistance;
    state.account.unitHeightWeight = payload.unitHeightWeight;
  },
  [mutation.SET_ADDITIONAL_EMAIL](state, payload) {
    state.additionalEmails.push(payload)
    state.account.additionalEmailAddresses.push(payload)
  },
  [mutation.REMOVE_ADDITIONAL_EMAIL](state, emailId) {
    state.additionalEmails = state.additionalEmails.filter(a => (a.id !== emailId))
    state.account.additionalEmailAddresses = state.account.additionalEmailAddresses.filter(a => (a.id !== emailId))
  },
  [mutation.UPDATE_SYSTEM_PRIVACY](state, payload) {
    state.account.systemWideActivityPrivacy = payload;
  },
  [mutation.SET_PLAYER_POSITIONS](state, payload) {
    state.playerPositions = payload;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
